<template>
    <div>
        <div class="testimonials-testimonial-wrapper">
            <Testimonial :testimonial="item" class="testimonials-testimonial-element" v-for="(item, index) in computedTestimonials" :key="index"/>
        </div>
        <div class="testimonials-testimonial-bullets-wrapper">
            <div class="testimonials-testimonial-bullet" :class="ind === 0 ? 'testimonials-active' : ''" @click="setCurrentPage(ind, $event)" v-for="(i, ind) in Array(Math.floor(testimonials.length / testimonialsPerPage))" :key="ind"></div>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import Testimonial from '@/components/ui/testimonials/Testimonial.vue';
    import gsap, { Power2 } from 'gsap';

    export default Vue.extend({
        name: 'Testimonials',
        components: {
            Testimonial
        },
        props: {
            testimonials: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                computedTestimonials: [],
                testimonialsPerPage: 3
            }
        },
        methods: {
            setCurrentPage( page: number, event: MouseEvent | null = null ) {
                if( event ) {
                    const bulletElement = event.target as HTMLElement;
                    [...document.querySelectorAll('.testimonials-testimonial-bullet')].forEach( elm => elm.classList.remove('testimonials-active') );
                    bulletElement.classList.add('testimonials-active');
                } else {
                    this.$data.computedTestimonials = this.testimonials.slice(page * this.$data.testimonialsPerPage,(page + 1) * this.$data.testimonialsPerPage)
                }

                this.animateChange();

                setTimeout(() => {
                    this.$data.computedTestimonials = this.testimonials.slice(page * this.$data.testimonialsPerPage,(page + 1) * this.$data.testimonialsPerPage)
                }, 600);
            },
            animateChange() {
                const tl = gsap.timeline();
                const textElements     = [...document.querySelectorAll('.testimonials-testimonial-element')];
                textElements.forEach( (elm, i) => tl.to( elm, .3, {color: 'transparent', bottom: '-30vh',  opacity: 0, ease: Power2.easeIn},  i === 0 ? 0 : '-=.1' ) )
                textElements.forEach( elm => tl.to( elm, .3, {color: '#fff', bottom: 0,  opacity: 1, ease: Power2.easeInOut}, '-=.1' ) )
            }
        },
        created() {
            this.setCurrentPage(0);
        }
    })
</script>

<style scoped lang="scss">
    .testimonials-testimonial {
        &-wrapper {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-gap: 2.5rem;
            width: 100%;
            padding: 0 2rem;
            margin-bottom: 3rem;
            margin-left: auto;
            margin-right: auto;
            max-width: 1200px;
        }

        &-element {
            margin-bottom: 2rem;
        }

        &-bullets {
            &-wrapper {
                width: 100%;
                display: flex;
                justify-content: center;
            }
        }

        &-bullet {
            width: 20px;
            height: 20px;
            background-color: #fff;
            border-radius: 50%;
            position: relative;
            margin-right: 1rem;
            z-index: 1;
            cursor: pointer;

                &::before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-color: #fff;
                    z-index: 2;
                    transform: scale(0);
                    -webkit-transform: scale(0);
                    transition: all .25s;
                }

            &:hover {
                &::before {
                    background-color: #8B8B8B;
                    transform: scale(.8);
                    -webkit-transform: scale(.8);
                }
            }

            &.testimonials-active {
                &::before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-color: #121315;
                    z-index: 2;
                    transform: scale(.8);
                    -webkit-transform: scale(.8);
                }
            }
        }

        @media SCREEN AND ( min-width: 576px ) {
            &-wrapper {
                grid-template-columns: repeat(3, 1fr);
            }

            &-element {
                margin-bottom: 0;
            }
        }
    }
</style>